import React from 'react';
import { Table } from '@mui/material';
import { ArcTableProps } from './types';

const ArcTable: React.FC<ArcTableProps> = (props) => {
  return <Table {...props} />;
};

export default ArcTable;